import type { FieldError, FieldErrors } from 'react-hook-form';

import type { ApplicantModalTab } from '../Tabs';
import { APPLICANT_MODAL_TABS } from '../Tabs';
import type { CreateApplicantFormValues } from './schemaCreateApplicantForm';

const isFieldError = (value: unknown): value is FieldError =>
    typeof value === 'object' && value !== null && 'message' in value && typeof value.message === 'string';

const countNestedErrors = (obj: unknown): number => {
    if (!obj || typeof obj !== 'object') return 0;

    if (isFieldError(obj)) return 1;

    let count = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const value of Object.values(obj as Record<string, unknown>)) {
        count += countNestedErrors(value);
    }
    return count;
};

export const getErrorCountsPerTab = (errors: FieldErrors<CreateApplicantFormValues>): Record<ApplicantModalTab, number> => {
    return {
        [APPLICANT_MODAL_TABS.PERSONAL_DATA]: countNestedErrors(errors.personendaten),
        [APPLICANT_MODAL_TABS.INCOME_AND_EXPENSES]:
            countNestedErrors(errors.einnahmen) + countNestedErrors(errors.ausgaben),
        [APPLICANT_MODAL_TABS.LIVING_SITUATION]: countNestedErrors(errors.wohnsituation),
        [APPLICANT_MODAL_TABS.REAL_ESTATE]: countNestedErrors(errors.immobilien),
        [APPLICANT_MODAL_TABS.EMPLOYMENT]: countNestedErrors(errors.beschaeftigung),
        [APPLICANT_MODAL_TABS.EXISTING_CREDITS]:
            countNestedErrors(errors.dispositionskredite) +
            countNestedErrors(errors.geschaeftskredite) +
            countNestedErrors(errors.immobiliendarlehen) +
            countNestedErrors(errors.kontokorrentkredite) +
            countNestedErrors(errors.kreditkarten) +
            countNestedErrors(errors.leasings) +
            countNestedErrors(errors.ratenkredite) +
            countNestedErrors(errors.sonstigeVerbindlichkeiten),
    };
};
